import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Load reCAPTCHA v3 dynamically if site key is configured
// reCAPTCHA v3 is optional - authentication works without it
const recaptchaV3SiteKey = import.meta.env.VITE_RECAPTCHA_V3_SITE_KEY?.trim();
if (recaptchaV3SiteKey && recaptchaV3SiteKey !== '') {
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaV3SiteKey}`;
  script.async = true;
  script.defer = true;
  script.onerror = () => {
    console.error('❌ Erro ao carregar script do reCAPTCHA v3. Verifique se a chave está correta.');
  };
  script.onload = () => {
    console.log('✅ reCAPTCHA v3 carregado com sucesso');
  };
  document.head.appendChild(script);
} else if (import.meta.env.DEV) {
  // Only log in development mode
  console.log('ℹ️ reCAPTCHA v3 não configurado (opcional)');
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);